var map = {
	"./feedback1-2.jpg": "b340",
	"./feedback10-2.jpg": "bb59",
	"./feedback2-2.jpg": "e0ba",
	"./feedback3-2.jpg": "7258",
	"./feedback4-2.jpg": "ab54",
	"./feedback5-2.jpg": "2592",
	"./feedback6-2.jpg": "0546",
	"./feedback7-2.jpg": "4659",
	"./feedback8-2.jpg": "5894",
	"./feedback9-2.jpg": "02f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3df2";